<sui-icon-button
  iconName="info"
  variant="ghost"
  radius="full"
  color="neutral"
  [size]="size()"
  [attr.aria-label]="ariaLabel() | translate"
  [attr.aria-haspopup]="'dialog'"
  (click)="open()"
></sui-icon-button>
